// extracted by mini-css-extract-plugin
export var list = "Progress-module--list--3z-qA";
export var dot = "Progress-module--dot--XTpeP";
export var active = "Progress-module--active--1XDKT";